/**
 * Provider logo components and the PROVIDER_LOGOS lookup map.
 */
import React from 'react';

export const GoogleLogo = () => (
  <img src="/google-logo.svg" width="36" height="36" alt="Google" />
);

export const MicrosoftLogo = () => (
  <svg viewBox="0 0 21 21" width="36" height="36">
    <rect x="1" y="1" width="9" height="9" fill="#F25022"/>
    <rect x="11" y="1" width="9" height="9" fill="#7FBA00"/>
    <rect x="1" y="11" width="9" height="9" fill="#00A4EF"/>
    <rect x="11" y="11" width="9" height="9" fill="#FFB900"/>
  </svg>
);

export const WebSearchLogo = () => (
  <svg viewBox="0 0 24 24" width="36" height="36" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8"/>
    <path d="M21 21L16.65 16.65" strokeLinecap="round"/>
  </svg>
);

export const FitbitLogo = () => (
  <svg viewBox="0 0 24 24" width="36" height="36">
    {/* Fitbit diamond dots pattern */}
    <circle cx="12" cy="3" r="1.8" fill="#00B0B9"/>
    <circle cx="8" cy="7" r="1.5" fill="#00B0B9"/>
    <circle cx="12" cy="7" r="2" fill="#00B0B9"/>
    <circle cx="16" cy="7" r="1.5" fill="#00B0B9"/>
    <circle cx="6" cy="11" r="1.2" fill="#00B0B9"/>
    <circle cx="10" cy="11" r="1.6" fill="#00B0B9"/>
    <circle cx="12" cy="11" r="2.2" fill="#00B0B9"/>
    <circle cx="14" cy="11" r="1.6" fill="#00B0B9"/>
    <circle cx="18" cy="11" r="1.2" fill="#00B0B9"/>
    <circle cx="8" cy="15" r="1.5" fill="#00B0B9"/>
    <circle cx="12" cy="15" r="2" fill="#00B0B9"/>
    <circle cx="16" cy="15" r="1.5" fill="#00B0B9"/>
    <circle cx="12" cy="19" r="1.8" fill="#00B0B9"/>
  </svg>
);

export const StravaLogo = () => (
  <svg viewBox="0 0 24 24" width="36" height="36">
    {/* Top arrow - bright orange */}
    <path d="M10.463 8.229l2.836 5.598h4.172L10.463 0l-7 13.828h4.169z" fill="#FC4C02"/>
    {/* Bottom arrow - light salmon */}
    <path d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066z" fill="#FC9C88"/>
  </svg>
);

export const ShopifyLogo = () => (
  <svg viewBox="0 0 109.5 124.5" width="36" height="36">
    <path d="M74.7,14.8c0,0-1.4,0.4-3.7,1.1c-0.4-1.3-1-2.8-1.8-4.4c-2.6-5-6.5-7.7-11.1-7.7c0,0,0,0,0,0 c-0.3,0-0.6,0-1,0.1c-0.1-0.2-0.3-0.3-0.4-0.5c-2-2.2-4.6-3.2-7.7-3.1c-6,0.2-12,4.5-16.8,12.2c-3.4,5.4-6,12.2-6.7,17.5 c-6.9,2.1-11.7,3.6-11.8,3.7c-3.5,1.1-3.6,1.2-4,4.5C9.1,40.7,0,111.2,0,111.2l75.6,13.1V14.6C75.2,14.7,74.9,14.7,74.7,14.8z M57.2,20.2c-4,1.2-8.4,2.6-12.7,3.9c1.2-4.7,3.6-9.4,6.4-12.5c1.1-1.1,2.6-2.4,4.3-3.2C56.9,12,57.3,16.9,57.2,20.2z M49.1,4.3 c1.4,0,2.6,0.3,3.6,0.9c-1.6,0.8-3.2,2.1-4.7,3.6c-3.8,4.1-6.7,10.5-7.9,16.6c-3.6,1.1-7.2,2.2-10.5,3.2 C31.7,19.1,39.8,4.6,49.1,4.3z M37.4,59.3c0.4,6.4,17.3,7.8,18.3,22.9c0.7,11.9-6.3,20-16.4,20.6c-12.2,0.8-18.9-6.4-18.9-6.4 l2.6-11c0,0,6.7,5.1,12.1,4.7c3.5-0.2,4.8-3.1,4.7-5.1c-0.5-8.4-14.3-7.9-15.2-21.7C23.8,51.8,31.4,40.1,48.2,39 c6.5-0.4,9.8,1.2,9.8,1.2l-3.8,14.4c0,0-4.3-2-9.4-1.6C37.4,53.5,37.3,58.2,37.4,59.3z M61.2,19c0-3-0.4-7.3-1.8-10.9 c4.6,0.9,6.8,6,7.8,9.1C65.4,17.7,63.4,18.3,61.2,19z" fill="#95BF47"/>
    <path d="M78.1,123.9l31.4-7.8c0,0-13.5-91.3-13.6-91.9c-0.1-0.6-0.6-1-1.1-1c-0.5,0-9.3-0.2-9.3-0.2s-5.4-5.2-7.4-7.2 V123.9z" fill="#95BF47"/>
  </svg>
);

export const NotionLogo = () => (
  <svg viewBox="0 0 24 24" width="36" height="36">
    <path d="M4.459 4.208c.746.606 1.026.56 2.428.466l13.215-.793c.28 0 .047-.28-.046-.326L17.86 2.68c-.42-.326-.98-.7-2.055-.607L3.01 3.013c-.466.047-.56.28-.374.466l1.823.73zm.793 3.172v13.854c0 .747.373 1.027 1.214.98l14.523-.84c.84-.046.933-.56.933-1.167V6.354c0-.606-.233-.933-.746-.886l-15.177.887c-.56.046-.747.326-.747.886v.14zm14.337.746c.093.42 0 .84-.42.888l-.7.14v10.264c-.606.327-1.166.514-1.633.514-.746 0-.933-.234-1.493-.934l-4.577-7.186v6.952l1.446.327s0 .84-1.166.84l-3.22.186c-.093-.186 0-.653.327-.746l.84-.233V9.854L7.822 9.76c-.093-.42.14-1.026.793-1.073l3.453-.233 4.764 7.279v-6.44l-1.213-.14c-.093-.514.28-.886.746-.933l3.224-.093zm-16.57-5.62L16.18 1.62c1.166-.093 1.446-.046 2.193.513l3.033 2.1c.607.467.84.7.84 1.306v15.254c0 1.12-.42 1.773-1.867 1.867l-15.457.933c-1.073.046-1.586-.093-2.146-.793l-2.38-3.053C.047 19.28 0 18.813 0 18.254V5.007c0-.747.42-1.4 1.353-1.493l1.666-.046z" fill="currentColor"/>
  </svg>
);

export const GitHubLogo = () => (
  <svg viewBox="0 0 24 24" width="36" height="36" fill="currentColor">
    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
  </svg>
);

export const LinearLogo = () => (
  <svg viewBox="0 0 24 24" width="36" height="36">
    <path d="M2.513 12.833a.25.25 0 0 1-.087-.333l4.388-7.596a.25.25 0 0 1 .341-.087l.667.385a.25.25 0 0 1 .087.341l-4.388 7.596a.25.25 0 0 1-.341.087l-.667-.393z" fill="#5E6AD2"/>
    <path d="M7.896 16.596a.25.25 0 0 1-.087-.341l4.388-7.596a.25.25 0 0 1 .341-.087l.667.385a.25.25 0 0 1 .087.341l-4.388 7.596a.25.25 0 0 1-.341.087l-.667-.385z" fill="#5E6AD2"/>
    <path d="M13.28 20.359a.25.25 0 0 1-.088-.341l4.388-7.596a.25.25 0 0 1 .341-.087l.667.385a.25.25 0 0 1 .087.341l-4.388 7.596a.25.25 0 0 1-.341.087l-.666-.385z" fill="#5E6AD2"/>
  </svg>
);

export const TogglLogo = () => (
  <svg viewBox="0 0 24 24" width="36" height="36">
    <path d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z" fill="#E57CD8"/>
    <path d="M17.667 12a5.667 5.667 0 1 1-11.334 0 5.667 5.667 0 0 1 11.334 0z" fill="#FFF"/>
  </svg>
);

export const WHOOPLogo = () => (
  <svg viewBox="0 0 24 24" width="36" height="36">
    <circle cx="12" cy="12" r="10" fill="none" stroke="#000" strokeWidth="2"/>
    <path d="M7 12h10M12 7v10" stroke="#000" strokeWidth="2"/>
  </svg>
);

export const AppleHealthLogo = () => (
  <svg viewBox="0 0 24 24" width="36" height="36">
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="#FF2D55"/>
  </svg>
);

export const StripeLogo = () => (
  <svg viewBox="0 0 24 24" width="36" height="36">
    <path d="M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.683-1.305 1.901-1.305 2.227 0 4.515.858 6.09 1.631l.89-5.494C18.252.975 15.697 0 12.165 0 9.667 0 7.589.654 6.104 1.872 4.56 3.147 3.757 4.992 3.757 7.218c0 4.039 2.467 5.76 6.476 7.219 2.585.92 3.445 1.574 3.445 2.583 0 .98-.84 1.545-2.354 1.545-1.875 0-4.965-.921-6.99-2.109l-.9 5.555C5.175 22.99 8.385 24 11.714 24c2.641 0 4.843-.624 6.328-1.813 1.664-1.305 2.525-3.236 2.525-5.732 0-4.128-2.524-5.851-6.591-7.305z" fill="#635BFF"/>
  </svg>
);

export const OuraLogo = () => (
  <svg viewBox="0 0 24 24" width="36" height="36">
    {/* Oura ring logo - horizontal line above circle */}
    <rect x="7" y="3" width="10" height="2.5" fill="#000"/>
    <circle cx="12" cy="16" r="6" fill="none" stroke="#000" strokeWidth="2.5"/>
  </svg>
);

export const CustomAPILogo = () => (
  <svg viewBox="0 0 24 24" width="36" height="36" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
  </svg>
);

export const GoogleAnalyticsLogo = () => (
  <svg viewBox="0 0 24 24" width="36" height="36">
    <rect x="4" y="14" width="4" height="6" rx="2" fill="#E37400"/>
    <rect x="10" y="8" width="4" height="12" rx="2" fill="#F57C00"/>
    <rect x="16" y="2" width="4" height="18" rx="2" fill="#FFA000"/>
  </svg>
);

export const PROVIDER_LOGOS: Record<string, React.FC> = {
  google: GoogleLogo,
  microsoft: MicrosoftLogo,
  google_analytics: GoogleAnalyticsLogo,
  web_search: WebSearchLogo,
  fitbit: FitbitLogo,
  strava: StravaLogo,
  shopify: ShopifyLogo,
  notion: NotionLogo,
  github: GitHubLogo,
  linear: LinearLogo,
  toggl: TogglLogo,
  whoop: WHOOPLogo,
  apple_health: AppleHealthLogo,
  stripe: StripeLogo,
  oura: OuraLogo,
  custom: CustomAPILogo,
};
